export default __webpack_public_path__ + "CarePlayAppIcon2024.png";